'use strict';

import $ from 'jquery';
import { queryString, redirectWithParams } from '../modules/query_params';
import { initTooltips } from '../modules/tooltips';
import DFClipboard from '../modules/clipboard';
import { isMobile } from '../modules/viewport';
import { onPageLoad } from '../modules/page_load';
import '../modules/jquery_modal_defaults';

onPageLoad(() => {
  // textarea and button to copy textarea's contents to clipboard
  $(document).on('click', '.s-button--copy-widget-code', () => {
    new DFClipboard('.js-copy-code-from').copy();
    $('.s-button--copy-widget-code').addClass('s-button--copied-widget-code');
    setTimeout(() => {
      $('.s-button--copy-widget-code').removeClass('s-button--copied-widget-code');
    }, 3000);
    return false;
  });

  // manage infobox on mobile
  $(document).on('touchstart touchend', () => {
    $('.infobox__container').hide();
  });
  $(document).on('touchstart touchend', '.infobox', (e) => {
    $(e.target).find('.infobox__container').show();
    return false;
  });
  $(document).on('touchstart touchend', '.infobox__container', (e) => {
    $(e.target).closest('.infobox').find('.infobox__container').hide();
    return false;
  });

  function autoGrowField(field, { initialHeight = 40, resetEmptyHeight } = {}) {
    if (!field) {
      return;
    }
    // reset field height
    field.style.height = 'inherit';
    const content = $(field).val();
    const fieldLink = $(field).siblings('.billable-item__website-link');
    const autogrowHeights = [];

    // calculate top and bottom padding to offset height calc
    const fieldPaddingOffsetTop = parseInt($(field).css('padding-top'), 10) || 0;
    const fieldPaddingOffsetBottom = parseInt($(field).css('padding-bottom'), 10) || 0;
    const fieldPaddingOffset = fieldPaddingOffsetTop + fieldPaddingOffsetBottom;

    // get the computed styles for the element
    let height = initialHeight + (field.scrollHeight - initialHeight - fieldPaddingOffset);
    const closestTr = $(field).closest('tr')[0];

    $(closestTr)
      .find('.textarea--autogrow, .field--autogrow')
      .toArray()
      .forEach((e) => {
        autogrowHeights.push(initialHeight + (e.scrollHeight - initialHeight - fieldPaddingOffset));
      });
    const highestField = Math.max.apply(0, autogrowHeights);

    // if the autogrow input is inside table, need to recalculate the column style
    if (highestField > initialHeight) {
      if (fieldLink.length) {
        closestTr.dataset.fieldPresent = 1;
      }
      const linkOffset = closestTr.dataset.fieldPresent ? 30 : 0;
      const maxContainerHeight = 240;
      const currentContainerHeight = 100 + highestField / 2;

      const containerHeight =
        currentContainerHeight + highestField / 4 < maxContainerHeight
          ? currentContainerHeight + highestField / 4
          : maxContainerHeight;

      if (closestTr) {
        closestTr.style.height = `${containerHeight + linkOffset}px`;
      }
    } else {
      if (closestTr) {
        closestTr.style.height = 'auto';
      }
    }
    const hasNewLine = $(field)
      .val()
      .match(/(\r\n|\r|\n)/gim);
    // add threshold length to reset height
    if (resetEmptyHeight && !hasNewLine && content.length < 70) {
      height = resetEmptyHeight;
    }
    field.style.height = `${height}px`;
    fieldLink.css('top', `${$(field).height() + 36}px`);
  }

  // init expand all field with autogrow class
  $('.field--autogrow, .textarea--autogrow').each((_, element) => {
    autoGrowField(element, { initialHeight: 26, resetEmptyHeight: 40 });
  });

  if ($('#exit-pop-up').length) {
    $(document).on('mouseout', function (e) {
      e = e ? e : window.event;
      if (e.target.tagName?.toLowerCase() === 'input') {
        return false;
      }
      const vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if (e.clientX >= vpWidth - 50) {
        return false;
      }
      if (e.clientY >= 50) {
        return false;
      }
      const from = e.relatedTarget || e.toElement;
      if (!from && document.cookie.indexOf('exit-pop-up-shown') < 0) {
        $('#exit-pop-up').modal();
        document.cookie = 'exit-pop-up-shown';
      }
    });
  }

  $(document).on('click', '.h-s-button--invite-field', (e) => {
    new DFClipboard('.field--invite-clients-block').copy();
    $(e.target)
      .closest('.invite-clients__copy-button-container')
      .find('.df-tooltip__text')
      .remove();
    $(e.target).before(
      `
      <span class="df-tooltip__text">Copied to Clipboard</span>
    `
    );
    $(e.target).closest('.invite-clients__copy-button-container').find('.df-tooltip__text').show();

    setTimeout(() => {
      $(e.target)
        .closest('.invite-clients__copy-button-container')
        .find('.df-tooltip__text')
        .fadeOut();
    }, 5000);

    return false;
  });

  (function () {
    const validPages = $('body').is('#client-register, #designer-register');
    const loggedIn = $('body').data().role;
    if ((validPages || loggedIn) && navigator.userAgent.indexOf('Trident') !== -1) {
      const msg = `For an optimal site experience, DesignFiles recommends using the latest versions of the following browsers:

Google Chrome, Mozilla Firefox, Edge, Safari.

(Internet Explorer is not supported)`;

      alert(msg);
    }
  })();

  $(document).on('click', '.main-nav__link--back-history', () => {
    window.history.go(-1);
    return false;
  });

  // handle main nav mobile dropdown
  $(document).on('click', '.main-nav__dropdown-trigger', () => {
    if (window.innerWidth < 990) {
      const $dropdownEl = $('.main-nav__dropdown');
      const $triggerEl = $('.main-nav__dropdown-trigger');
      $dropdownEl.toggle();
      $triggerEl.toggleClass('main-nav__dropdown-trigger--expanded');
    }
  });
  function prepareMainNavDropdownMenu() {
    const $dropdownEl = $('.main-nav__dropdown');
    // hide dropdown menu initially on mobile devices
    if (isMobile()) {
      $dropdownEl.hide();
    } else {
      $dropdownEl.show();
    }
  }
  $(document).ready(prepareMainNavDropdownMenu);
  $(window).resize(prepareMainNavDropdownMenu);

  // clickable header
  $('.page-header--clickable').on({
    click: (e) => {
      e.target.contentEditable = true;
      e.target.spellcheck = true;
      e.target.focus();
    },
    blur: (e) => {
      e.target.contentEditable = false;
      e.target.spellcheck = false;
    },
    keydown: (e) => {
      if (e.which === 13) {
        e.preventDefault();
      }
    },
    keyup: (e) => {
      if (e.which === 13) {
        e.target.blur();
      }
    },
  });

  // handler for autogrow field
  $(document).on('input', 'field, .field--autogrow, .textarea--autogrow', (e) => {
    if ($(e.target).hasClass('textarea--autogrow') || $(e.target).hasClass('field--autogrow')) {
      autoGrowField(e.target, { initialHeight: 26, resetEmptyHeight: 40 });
    } else {
      autoGrowField(e.target);
    }
  });

  $(document).ready(function () {
    const $field = $(
      '.field--mobile-project-subnav, .field--mobile-settings-subnav, .field--financials-table-subnav'
    );
    $field.on('change select', (e) => {
      const url = $(e.target).val();
      window.location.href = url;
    });
  });

  // To show or not to show clear button(cross on the search box)
  $(document).on('keyup', '.search-field', (e) => {
    const $el = $(e.target);
    const $clearElement = $el.siblings('.search-field-clear');

    $clearElement.toggle($el.val().length > 0);

    // custom handlers
    if ($el.hasClass('search-field--order-tracker')) {
      const seachQuery = $el.val().toLowerCase();

      $('.order-tracker__vendor').hide();
      $('.order-tracker-form-table tr').hide();

      $('.order-tracker-form-table').each((_, table) => {
        let lastHeadingRow = null;

        $(table)
          .find('tbody tr')
          .each((_, row) => {
            if (row.classList.contains('order-tracker-form-table__source-row')) {
              lastHeadingRow = row;
              return;
            }

            const $row = $(row);
            if ($row.attr('data-search-by').match(seachQuery)) {
              lastHeadingRow && $(lastHeadingRow).show();

              const orderVendor = $row
                .show()
                .closest('.order-tracker-form-table')
                .find('thead')
                .find('tr')
                .show()
                .closest('.order-tracker__vendor')
                .show()
                .find('.order-tracker-header__fold-icon')
                .removeClass('order-tracker-header__fold-icon--closed')
                .closest('.order-tracker__vendor');

              orderVendor.find('.top-scrollbar').toggleClass('hide');

              hideTableContainer(seachQuery, orderVendor);
            }
          });
      });

      $('.order-tracker__vendor:visible').each((index, el) => {
        if (index === 0) {
          return;
        }

        $(el)
          .find('.order-tracker-header__fold-icon')
          .toggleClass('order-tracker-header__fold-icon--closed');
        $(el).find('.order-tracker-form-table-container').toggleClass('hide');
        $(el).find('.top-scrollbar').toggleClass('hide');
      });

      if (seachQuery === '') {
        $('.order-tracker__vendor').each((_, el) => {
          const $orderVendor = $(el);
          const $foldIcon = $orderVendor.find('.order-tracker-header__fold-icon');
          const $container = $orderVendor.find('.order-tracker-form-table-container');

          $orderVendor.show();
          $orderVendor.find('.top-scrollbar').toggleClass('hide');
          $foldIcon.toggleClass('order-tracker-header__fold-icon--closed');
          $container.toggleClass('hide');
        });
        $('.order-tracker-form-table tr').show().css('background', 'none');
      }

      // Show the message if no results are found
      if ($('.order-tracker__vendor:visible').length === 0) {
        $('.order-tracker-no-result').removeClass('hide');
        $('.order-tracker__controls').addClass('hide');
        $('.order-tracker-no-result__search-query').text(`"${seachQuery}"`);
      } else {
        $('.order-tracker-no-result').addClass('hide');
        $('.order-tracker__controls').removeClass('hide');
      }
    }
  });

  const hideTableContainer = (seachQuery, orderVendor) => {
    const orderContainer = orderVendor
      .find('.order-tracker-form-table-container')
      .removeClass('hide');

    orderVendor.find('.top-scrollbar').removeClass('hide');
    if (seachQuery === '') {
      orderContainer.addClass('hide');
      orderVendor.find('.top-scrollbar').addClass('hide');
      orderVendor
        .find('.order-tracker-header__fold-icon')
        .addClass('order-tracker-header__fold-icon--closed');
    }
  };

  // On search box clear
  $(document).on('click', '.search-field-clear', () => {
    const params = queryString();
    const $searchField = $('.search-field');
    const $form = $searchField.parents('form');

    $searchField.val('').focus();

    if ($form.length) {
      $form.submit();
    } else {
      params['q'] = '';
      redirectWithParams(params);
    }
  });

  // remove responsive table container shadow on reach scroll end
  function checkResponsiveTableScroll() {
    const $el = $('.responsive-table-container');
    if ($el.length) {
      const scrollTresshold = 5;
      const scrollLeft = $el.scrollLeft();
      const scrollWidth = $el.get(0).scrollWidth;
      const isHaveScroll = scrollWidth > $el.innerWidth();
      const isAtEnd =
        scrollLeft + $el.innerWidth() >= scrollWidth - scrollTresshold && scrollLeft > 0;
      if (isAtEnd) {
        $el.addClass('responsive-table-container--left-shadow');
        $el.removeClass('responsive-table-container--right-shadow');
      } else if (isHaveScroll) {
        $el.addClass('responsive-table-container--right-shadow');
        $el.removeClass('responsive-table-container--left-shadow');
      } else {
        $el.removeClass('responsive-table-container--left-shadow');
        $el.removeClass('responsive-table-container--right-shadow');
      }
    }
  }

  $('.responsive-table-container').on('scroll', checkResponsiveTableScroll);

  /* eslint-disable new-cap */
  if ($('body').is('#designer-register, #login')) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // name-based: the client login form namespaces its field ids
    $('input[name="user[time_zone]"]').val(timezone);
  }

  $(document).on($.modal.OPEN, '.video-modal--js-load', (e) => {
    const videoId = $(e.target).data('video-id');
    $(e.target)
      .find('.video-modal__iframe')
      .attr('src', `https://www.youtube.com/embed/${videoId}?rel=0`);
  });

  $(document).on('click', '.scroll-to-page-top', (e) => {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 400);
  });

  $(document).on('click', '.h-s-button--referral', function () {
    const $fieldReferral = $(this).siblings('.field--referral');
    new DFClipboard($fieldReferral).copy();

    setTimeout(() => {
      initTooltips($(this));
    }, 4000);

    return false;
  });
});
